import "./core.css";
import "./Forms.css";
import { GameScreens } from "./game/";
import { SettingsScreens } from "./settings/SettingsScreens";
import { RegisterScreenModes } from "./modes/RegisterScreenModes.js";
import { BloomRoot } from "elmtree";
import { UISystem } from "../system/ui/UISystem";
export async function InitScreens() {
    RegisterScreenModes();
    GameScreens();
    SettingsScreens();
    BloomRoot(UISystem.appScreen.render());
    UISystem.appScreen.update("select-entity", "model-view");
    // UISystem.appMenu.setActiveNode("main", "entity");
}
